import { FC } from 'react'
import cx from 'classnames'

import { PeriodTableProps } from '../PeriodTable'

import * as SC from './styled'

export type AdsReplacementDateProps = {
  className?: string
  title: string
  subtitle?: {
    label: string
    requestedDate: string
  }
  periods?: {
    label: string
    start?: string
    finish?: string
    months?: Array<string>
  }
  frequency?: {
    label: string
    value: string
  }
  periodTable?: PeriodTableProps
}

const AdsReplacementDate: FC<AdsReplacementDateProps> = ({
  className,
  title,
  subtitle,
  periods,
  frequency,
  periodTable,
}) => {
  return (
    <SC.AdsReplacementDate className={cx('AdsReplacementDate', className)}>
      <SC.Title>{title}</SC.Title>
      <SC.Container>
        <SC.Top>
          {subtitle && (
            <SC.Subtitle>
              {subtitle?.label && (
                <SC.SubtitleLabel>{subtitle.label}</SC.SubtitleLabel>
              )}
              {subtitle?.requestedDate && (
                <SC.RequestedDate>{subtitle.requestedDate}</SC.RequestedDate>
              )}
            </SC.Subtitle>
          )}
        </SC.Top>
        <SC.Bottom>
          <SC.PeriodsFrequencyWrapper>
            {periods && (
              <SC.Wrapper>
                {periods.label && <SC.Label>{periods.label}</SC.Label>}
                {periods.start && <SC.Value>{periods?.start}</SC.Value>}
                {periods.finish && <SC.Value>{periods?.finish}</SC.Value>}
                {periods.months && (
                  <SC.Value>{periods.months.join(', ')}</SC.Value>
                )}
              </SC.Wrapper>
            )}
            {frequency && (
              <SC.Wrapper>
                {frequency.label && <SC.Label>{frequency.label}</SC.Label>}
                {frequency.value && <SC.Value>{frequency.value}</SC.Value>}
              </SC.Wrapper>
            )}
          </SC.PeriodsFrequencyWrapper>
          {periodTable && <SC.TablePeriod {...periodTable} />}
        </SC.Bottom>
      </SC.Container>
    </SC.AdsReplacementDate>
  )
}

export default AdsReplacementDate
